import React from 'react';
import { Page } from '../Page';
import { HeartPulse, Footprints, Smile, Zap } from 'lucide-react';
export function Page10() {
  return <Page pageNumber={26} variant="light" data-id="element-281">
      <div className="flex flex-col h-full" data-id="element-282">
        {/* Hero Image Header */}
        <div className="relative h-[380px] -mx-12 -mt-10 mb-10 overflow-hidden" data-id="element-283">
          <img src="https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=1000&q=80" alt="Cardio running" className="w-full h-full object-cover" data-id="element-284" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/60 to-transparent" data-id="element-285" />

          <div className="absolute bottom-0 left-12 right-12 pb-6" data-id="element-286">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-287">
              The Essentials
            </p>
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight" data-id="element-288">
              Cardiovascular <span className="text-tealslate" data-id="element-289">Health</span>
            </h1>
          </div>
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-8 max-w-2xl" data-id="element-290">
          While weight lifting protects your metabolism and muscle mass, cardio
          protects your heart and improves your stamina. You need both, but they
          serve different purposes.
        </p>

        <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 text-center mb-10" data-id="element-291">
          <h2 className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-292">
            The Goal
          </h2>
          <div className="text-3xl font-serif text-[#1F1F1F] mb-2" data-id="element-293">
            150 Minutes Per Week
          </div>
          <p className="text-xs text-[#7A7A70] leading-[1.8] max-w-md mx-auto" data-id="element-294">
            Aim for a pace where singing is hard and talking takes effort. Brisk
            walking, jogging, or dancing all count.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-6 mb-10" data-id="element-295">
          <div className="flex flex-col items-center text-center" data-id="element-296">
            <HeartPulse className="w-8 h-8 text-tealslate mb-3" data-id="element-297" />
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-1" data-id="element-298">
              Heart Health
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-299">
              Strengthens your cardiovascular system.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-300">
            <Smile className="w-8 h-8 text-tealslate mb-3" data-id="element-301" />
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-1" data-id="element-302">
              Mood Boost
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-303">
              Releases endorphins and reduces stress.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-304">
            <Zap className="w-8 h-8 text-tealslate mb-3" data-id="element-305" />
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-1" data-id="element-306">
              More Energy
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-307">
              Builds stamina for everyday activities.
            </p>
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-end space-y-4" data-id="element-308">
          <div className="flex items-start gap-4 border-t border-[#D8D8D0] pt-6" data-id="element-309">
            <Footprints className="w-6 h-6 text-tealslate shrink-0 mt-1" data-id="element-310" />
            <div data-id="element-311">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-312">
                Start Simple
              </h3>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-313">
                Any movement is better than none. Once you start, it gets easier
                to build from there.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4" data-id="element-314">
            <div className="w-6 h-6 rounded-full bg-tealslate text-white flex items-center justify-center font-bold shrink-0 mt-1 text-sm" data-id="element-315">
              !
            </div>
            <div data-id="element-316">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-317">
                The 10-Minute Rule
              </h3>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-318">
                Start with walking if you're new to exercise. Even 10-minute
                walks after meals can make a significant difference for blood
                sugar control.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}